import { createAction } from '@reduxjs/toolkit'
import { GET_SKILLS, GET_SKILLS_SUCCESSFUL, GET_SKILLS_FAILURE } from './types'

export const getSkills = createAction(GET_SKILLS)
export const getSkillsSuccessful = createAction(GET_SKILLS_SUCCESSFUL)
export const getSkillsFailure = createAction(GET_SKILLS_FAILURE)
